import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=d3e01df0&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=d3e01df0&prod&lang=scss"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=d3e01df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e01df0",
  null
  
)

export default component.exports